import React from 'react';
import { ModalContent } from 'fronton-react';
import { List, ListItem, ModalHeader, Typography } from 'common/components';
import {
  newKitchenUtpSectionModalContent,
  newKitchenUtpSectionModalList,
  newKitchenUtpSectionModalText,
} from '../../new-kitchen-utp-section-styles';

export const DeliniaId: React.FC = () => (
  <>
    <ModalHeader title="Собственный бренд Delinia&nbsp;ID" />
    <ModalContent className={newKitchenUtpSectionModalContent}>
      <Typography className={newKitchenUtpSectionModalText} variant="m" size="body_long" adaptive={false}>
        Мы&nbsp;продаём кухни собственной торговой марки Delinia ID&nbsp;более 10&nbsp;лет. Продукция Delinia
        ID&nbsp;прослужит долгие годы, ведь она эргономична и&nbsp;проста в&nbsp;уходе, а&nbsp;практичные
        дизайнерские решения позволят вам организовать комфортное и&nbsp;уютное пространство.
      </Typography>
      <List listStyle="disc" className={newKitchenUtpSectionModalList}>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Большой выбор мебельной фурнитуры и&nbsp;аксессуаров
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Точность изготовления всех деталей
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Ровные и&nbsp;гладкие поверхности
          </Typography>
        </ListItem>
        <ListItem>
          <Typography variant="m" size="body_long" adaptive={false}>
            Ручной контроль качества изделия
          </Typography>
        </ListItem>
      </List>
    </ModalContent>
  </>
);
